import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";

export default class APIUser extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getUserId = async (userId: UUID): Promise<types.OfferResponse[]> => {
    let res = await this._fetch({
      url: `/offers/user/${userId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
